import React from "react";
import { t } from "../../lib/i18n";

export default function ErrorBanner({ onRetry, message }) {
  return (
    <div
      data-testid="error-banner"
      role="alert"
      className="flex flex-col items-start gap-3 rounded-md border border-[#C8A24B]/40 bg-white px-5 py-4 text-sm text-[#1A1A1A]/80 sm:flex-row sm:items-center sm:justify-between"
    >
      <p>{message || t("generic.error")}</p>
      {onRetry ? (
        <button
          type="button"
          data-testid="error-retry"
          onClick={onRetry}
          className="rounded-full border border-[#1A1A1A]/15 px-4 py-1.5 text-xs uppercase tracking-[0.2em] transition hover:border-[#C8A24B] hover:text-[#C8A24B]"
        >
          {t("generic.retry")}
        </button>
      ) : null}
    </div>
  );
}
